import React from 'react';
import { Zap, Phone, MessageCircle, Globe } from 'lucide-react';
import { features } from '../../data/mockData';

const FeaturesSection = () => {
  const iconMap = {
    zap: Zap,
    phone: Phone,
    'message-circle': MessageCircle,
    globe: Globe
  };

  return (
    <section className="bg-gray-50 py-24" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <header className="text-center mb-16">
          <span className="text-sm font-medium text-purple-600 mb-3 block">Features</span>
          <h2 id="features-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Everything you need to{' '}
            <span className="text-gray-400">automate</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Deploy AI agents that handle conversations across voice, chat, and web - all from one platform.
          </p>
        </header>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" role="list" aria-label="Platform features">
          {features.map((feature) => {
            const Icon = iconMap[feature.icon] || Zap;
            return (
              <article
                key={feature.id}
                role="listitem"
                className="group p-6 rounded-2xl bg-white border border-gray-200 hover:border-gray-300 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" aria-hidden="true">
                  <Icon className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="text-gray-900 font-semibold text-lg mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
